import LoginPage from "./components/LoginPage.vue";

export default [
  {
    path: "/account/login",
    name: "LoginPage",
    component: LoginPage,
    meta: {
      auth: false,
    },
  },
];
